<template>
  <div class="margin-left-3x">
    <div class="margin-top">联系方式</div>
    <div class="margin-top">
      <input
        class="f-g3 h2 border-none bg-g10 padding width-690"
        placeholder="留下联系方式，更可能解决问题～"
        v-model="number"
      />
    </div>
    <div class="margin-top">问题和意见</div>
    <textarea
          class="f-g2 h2 border-none padding-3x bg-g10 border-3x box margin-top"
          maxlength="500"
          placeholder="请输入您要反馈的问题（5-500字以内）"
          v-model="summary"
        ></textarea>
        <div class="margin-top">图片（选填，提供问题截图）</div>
        <van-uploader
          :accept="'image/*'"
          multiple
          class="margin-top margin-bottom"
          v-model="fileList"
          :after-read="afters"
          
        >
        
          <img
            :src="uploadpath + 'resource/' + Res.add"
            alt=""
            class="icon-11x"  
          />          
        </van-uploader>
        <button
        class="
          wrap4
          border-10x
          f-w h2
          border-none
          margin-top-10x margin-right-7x
        "
        style="background: linear-gradient(-3deg, #9D9B2A 0%, #B8B62D 100%);"
        @click="tijiao"
      >
        提交意见
      </button>
      <img
        class="icon-11x under2"
        :src="uploadpath + 'resource/' + Res.back"
        alt=""
        @click="routeto('/')"
      />
  </div>
</template>
<script>
import Config from "../Config";
import { PageHelper } from "../PageHelper";
import { HttpHelper } from "../HttpHelper";
import { Utils } from "../Utils";
import { Toast } from "vant";

export default {
  data() {
    return {
      Res: {},
      Inst: {},
      Member: [],
      bannerlist: [],
      productlist: [],
      problemlist: [],
      attrlist: [],
      list: [],
      show: false,
      right: "A",
      number: "",
      summary: "",
      dialogImageUrl: "",
      dialogVisible: false,
      pritureList:[],
      fileList:[],
      mobile:''
    };
  },
  created() {
    PageHelper.Init(this);

    this.mobile=window.localStorage.getItem("mobile");
    HttpHelper.Post("Member/info", {phone: this.mobile}).then((ret) => {
      this.Member = ret;
      console.log(ret)
    });
    
  },
  methods:{
    tijiao() {
       console.log( JSON.stringify(this.pritureList))
       if(this.summary.length<5){
        Toast.fail("请输入至少5个字");
       }else{
        console.log(JSON.stringify(this.pritureList))
        HttpHelper.Post("member/suggest", {
        member_id: this.Member.id,
        number: this.number,
        summary: this.summary,
        img:JSON.stringify(this.pritureList)
      }).then((ret) => {
        console.log(ret)
        if (ret.code == 0) {
          Toast.success("感谢您的建议");
          this.routeto("/");
        }
      });
       }
      
    },
    afters(file){
      console.log("file",file);
      HttpHelper.UploadBase64("suggestimg",file.content, (e) =>{
        file.message = `${e}%`;
      }).then((ret) =>{
        console.log(ret)
        this.pritureList.push({img:ret.result})
        file.status = "done"
        console.log(this.pritureList);
      })
    },
  }
};
</script>
<style scoped>
.box{
  height: 320px; 
  width: 690px
}
</style>


// WEBPACK FOOTER //
// src/components/Suggest.vue